import { EVENT_OPEN_DAILY_REWARD_MODAL } from "../constants";

export function openDailyRewardModal() {
  window.dispatchEvent(new Event(EVENT_OPEN_DAILY_REWARD_MODAL));
}
